import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface LiveIndicatorProps {
  label?: string;
  className?: string;
  /**
   * Socket state, passed in rather than subscribed to.
   *
   * Required on purpose: the badge used to hard-code LIVE, so a dropped socket
   * left a green light over frozen prices and stale PnL — a user could size or
   * exit against a number that stopped updating minutes earlier. Making it
   * optional would let a call site silently reintroduce that.
   *
   * It must NOT subscribe internally: useStatsWebSocket keeps its ref per hook
   * instance with no shared provider on web, so every badge would open its own
   * connection — three extra sockets per dashboard mount.
   */
  connected: boolean;
}

export function LiveIndicator({ label, className, connected }: LiveIndicatorProps) {
  const { t } = useTranslation("common");
  if (!connected) return null;
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <span className="inline-flex rounded-full h-2 w-2 bg-success" />
      <span className="text-xs font-medium text-success uppercase tracking-wider">
        {label ?? t("live.badge")}
      </span>
    </div>
  );
}
